module.exports = __webpack_public_path__ + "media/Images/LeafBig1-27129d13.svg";